// opervex-frontend/src/routes/registerRoutes.js

import SalesOrder from "../pages/Sales/SalesOrder";

const registerRoutes = [
  // Sales Order
  { path: "Sales/SalesOrder", private: true, component: <SalesOrder />, role: "SALES_ORDER" },
  { path: "Sales/SalesOrder/:id", private: true, component: <SalesOrder />, role: "SALES_ORDER" },
];

export default registerRoutes;
